import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

const MY_BUDDIES = gql`
  query myBuddies {
    myBuddies {
      id
      name
      handle
      email
      profileImage
      homeClubName
      homeClubId
      handicap
      countryCode
      birthday
      teeLength
      sex
      createdAt
      isManagedBy
    }
    getGhosts {
      id
      name
      handle
      email
      homeClubName
      homeClubId
      handicap
      countryCode
      birthday
      teeLength
      sex
      type
    }
  }
`

const PENDING_BUDDY_REQUESTS = gql`
query pendingRequests {
  pendingRequests {
    id # requestId
    from { # from is a Buddy type!
      id
      name
      handle
      profileImage
      homeClubName
      homeClubId
      handicap
      orgIds
      commonBuddies
      commonGames
    }
  }
}
`

export const SEARCH_FOR_BUDDY = gql`
  query searchForBuddy($query: String!) {
    searchForBuddy(query: $query) {
      id
      name
      handle
      email
      profileImage
      homeClubName
      homeClubId
      handicap
    }
  }
`

export const SEND_BUDDY_REQUEST = gql`
  mutation sendBuddyRequest($to: String!) { # $to is userId (UUID)
  sendBuddyRequest(to: $to)
}
`

const SEND_BUDDY_INVITE = gql`
  mutation sendBuddyInvite($email: String!) {
    sendBuddyInvite(email: $email)
  }
`

const UPSERT_GHOST = gql`
  mutation upsertGhost($input: UpsertGhostInput!) {
    upsertGhost(input: $input) {
      id
      name
      handle
      email
      countryCode
      birthday
      sex
      handicap
      clubId
      clubName
      teeLength
    }
  }
`

const ACCEPT_REQUEST = gql`
  mutation acceptRequest($id: ID!) {
    respondToRequest(id: $id, accept: true)
  }
`

const REJECT_REQUEST = gql`
  mutation rejectRequest($id: ID!) {
    respondToRequest(id: $id, accept: false)
  }
`

const REMOVE_BUDDY = gql`
  mutation removeBuddy($id: String!) {
    removeBuddy(id: $id)
  }
`

export const REMOVE_GHOST = gql`
  mutation removeGhost($id: String!) {
    removeGhost(id: $id)
  }
`

export const SET_MANAGED = gql`
  mutation setManaged($id: String!) {
    setAsManaged(userId: $id)
  }
`

export const REMOVE_MANAGED = gql`
  mutation removeManaged($id: String!) {
    removeAsManaged(userId: $id)
  }
`

export const myBuddiesLoader = graphql(MY_BUDDIES, {
  name: 'myBuddies',
  options: props => ({
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  })
})

export const pendingRequestsLoader = graphql(PENDING_BUDDY_REQUESTS, {
  name: 'pendingRequests',
  options: props => ({
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    pollInterval: 1000 * 10 // 10 seconds
  })
})

export const searchForBuddyLoader = graphql(SEARCH_FOR_BUDDY, {
  name: 'searchForBuddy',
  options: props => ({
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    variables: {
      query: props.query
    }
  }),
  skip: props => !props.query
})

export const sendBuddyRequestLoader = graphql(SEND_BUDDY_REQUEST, {
  name: 'sendBuddyRequest'
})

export const sendBuddyInviteLoader = graphql(SEND_BUDDY_INVITE, {
  name: 'sendBuddyInvite'
})

export const upsertGhostLoader = graphql(UPSERT_GHOST, {
  name: 'upsertGhost',
  options: props => ({
    refetchQueries: [{ query: MY_BUDDIES }]
  })
})

export const acceptRequestLoader = graphql(ACCEPT_REQUEST, {
  name: 'acceptRequest'
})

export const rejectRequestLoader = graphql(REJECT_REQUEST, {
  name: 'rejectRequest'
})

export const removeBuddyLoader = graphql(REMOVE_BUDDY, {
  name: 'removeBuddy'
})

export const removeGhostLoader = graphql(REMOVE_GHOST, {
  name: 'removeGhost',
  options: props => ({
    refetchQueries: [{ query: MY_BUDDIES }]
  })
})
